import athenaConfig from '../config';
import { getRequestState } from './widget-facade';
import { autoSubmitPostForm } from './html-utils';


export async function launchLwa({ emailToken, hash, error_details }:
  { emailToken?: string; hash?: string; error_details?: string }) {
  const { postToOkta } = global.settings;
  const { lwaBaseUri, authServerId } = athenaConfig;

  const lwaAuthorizeUrl = new URL(`oauth2/${authServerId}/v1/authorize`, lwaBaseUri);

  hash && (lwaAuthorizeUrl.hash = hash);
  if (postToOkta) {
    const state = JSON.parse(getRequestState()) as Record<string, any>;
    const originalAuthorizeParams = state.authorizePostParamsObject as Record<string, string>;
    const params = { ...originalAuthorizeParams };
    if (emailToken) {
      params.registration_token = emailToken;
    }
    if (error_details) {
      params.error_details = error_details;
    }
    autoSubmitPostForm({ action: lwaAuthorizeUrl.toString(), params });
  }
  else {
    const { originalRedirectUri } = global.settings;
    if (originalRedirectUri) {
      const queryParams = originalRedirectUri.searchParams;
      for (const [ key, value ] of queryParams) {
        lwaAuthorizeUrl.searchParams.set(key, value);
      }
      // registration_token has highest priority over other token params,
      // so use this in case there is another email token in the URL already
      emailToken && lwaAuthorizeUrl?.searchParams.set('registration_token', emailToken);
      error_details && (lwaAuthorizeUrl.searchParams.set('error_details', error_details));
      window.location.assign(lwaAuthorizeUrl.toString());
    }
  }
}
